<template>
  <v-container fluid v-if="azienda_sel == 'ferraraquarzi'">
    <!-- Tabella -->
    <v-data-table v-if="data_table === true" :headers="headers_ferrara" fixed-header
      :items="autisti.filter((a) => a.validita == true).reverse()" :items-per-page="10" item-key="id_conduttore"
      calculate-widths class="elevation-1 mt-5" height="60vh">
      <!-- Intestazione tabella -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Autisti
            <v-icon color="white"> mdi-card-account-details </v-icon>
          </v-toolbar-title>
          <!-- Aggiungi autista -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="nuovoAutista()" class="ml-auto mr-n15" v-bind="attrs" v-on="on" small>
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuovo autista</span>
          </v-tooltip>
          <!-- Visualizza filtri -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto mr-5" v-bind="attrs" v-on="on" small
                @click="filters == true ? (filters = false) : (filters = true)">
                <v-icon color="purple"> mdi-filter </v-icon>
              </v-btn>
            </template>
            <span v-if="filters == false">Visualizza Filtri</span>
            <span v-else>Nascondi Filtri</span>
          </v-tooltip>
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="goBack()" class="ml-15" v-bind="attrs" v-on="on" small>
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Vai alla Dashboard</span>
          </v-tooltip>
        </v-toolbar>
        <!-- Input Filtri -->
        <v-row v-if="filters === true" justify="center" class="ma-1">
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="matricola_filter" label="Matricola" dense hide-details
              class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="nome_filter" label="Nome" dense hide-details class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="cognome_filter" label="Cognome" dense hide-details class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="codice_fiscale_filter" label="Cod. Fiscale" dense hide-details
              class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="luogo_nascita_filter" label="Luogo di nascita" dense hide-details
              class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-autocomplete @change="filtra()" label="Patente" v-model="patente_filter" dense hide-details
              :items="items_patente" class="mt-5" item-text="descrizione" item-value="id_abilitazione" />
          </v-col>
          <v-col cols="4" md="3">
            <v-autocomplete @change="filtra()" v-model="veicolo_filter" label="Veicolo" dense :items="items_veicolo"
              item-text="targa" item-value="id_macchina" hide-details class="mt-5" />
          </v-col>
          <v-col cols="1">
            <!-- Reset filtri -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mt-5" v-bind="attrs" v-on="on" small @click="resetFiltri()">
                  <v-icon color="error"> mdi-filter-off </v-icon>
                </v-btn>
              </template>
              <span>Resetta Filtri</span>
            </v-tooltip>
          </v-col>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="filtra()" class="mt-4 success" v-bind="attrs" v-on="on">
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Filtra</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
      <!-- Pulsante edit -->
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="
              selectItem(item);
            data_table = false;
            ">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Dettagli</span>
        </v-tooltip>
      </template>
      <!-- Pulsante competenza -->
      <template v-slot:[`item.competenza`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="openDialogAreaComp(item)">
              <v-icon color="primary">mdi-map-search</v-icon>
            </v-btn>
          </template>
          <span>Area di competenza</span>
        </v-tooltip>
      </template>
      <!-- Patente -->
      <template v-slot:[`item.abilitazioni`]="{ item }">
        <template v-for="i in item.abilitazioni">
          <span v-if="i.id_conduttore === item.id_conduttore" :key="i.id_conduttore_abilitazione">
            {{ i.abilitazione }}
          </span>
        </template>
      </template>
      <!-- Veicoli -->
      <template v-slot:[`item.predefinito`]="{ item }">
        <span v-for="i in item.macchine" :key="i.id_macchina" :style="{ color: i.predefinito == 1 ? 'green' : 'black' }">
          {{ i.targa }}
        </span>
      </template>

      <!-- Pulsante rimuovi -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="
              selectItem(item);
            delete_dialog = true;
            ">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Create/Edit template -->
    <template v-if="data_table === false">
      <v-card min-height="60vh" class="mt-5">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Autisti
            <v-icon color="white"> mdi-card-account-details </v-icon>
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto" @click="salvaAutista()" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva modifiche</span>
          </v-tooltip>
          <v-spacer />
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto" @click="data_table = true" v-bind="attrs" v-on="on" small>
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <!-- Input -->
          <v-row justify="center" class="ma-1">
            <v-col cols="3">
              <v-text-field v-model="selected_item.nome" label="Nome" dense hide-details />
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="selected_item.cognome" label="Cognome" dense hide-details />
            </v-col>
            <v-col cols="3">
              <v-text-field type="number" hide-spin-buttons v-model.number="selected_item.matricola" label="Matricola"
                dense hide-details />
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="selected_item.codice_fiscale" label="Cod. Fiscale" dense hide-details />
            </v-col>
            <v-col cols="2">
              <v-text-field v-model="selected_item.luogo_nascita" label="Luogo di nascita" dense hide-details />
            </v-col>
            <v-col cols="2">
              <v-text-field type="date" dense hide-details label="Data di nascita"
                v-model="selected_item.data_nascita" />
            </v-col>
            <v-col cols="2">
              <v-autocomplete v-model="selected_item._abilitazioni" dense hide-details :items="items_patente" multiple
                item-text="descrizione" item-value="id_abilitazione" label="Competenze">
                <!-- <template #label>
                  <span>Competenze<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules v-on:dialogModules="aggiornaAutocomplete" tipo="CONDUTTORE_ABILITAZIONE" nome="Patente"
                      setaction="settabelle" getaction="gettabelle" controller="Magazzino" filter="validita = 1"
                      :dati="[{ des: '' }]" />
                  </a>
                </template> -->
              </v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-select label="Motrice" v-model="selected_item.macchine" dense hide-details multiple :items="motrici"
                item-text="codice" item-value="id_macchina" return-object @change="changeMacchine()" />
            </v-col>
            <v-col cols="3" v-if="selected_item.macchine?.length != 0">
              <v-select @change="selectMotricePred()" label="Motrice predefinita" v-model="motrice_predefinita" dense
                hide-details :items="selected_item.macchine" item-text="targa" item-value="id_macchina" />
            </v-col>

            <v-col cols="8">
              <v-textarea class="mt-2" rows="4" outlined v-model="selected_item.note" label="Note" dense hide-details />
            </v-col>
            <v-col cols="4">
              <v-color-picker v-model="selected_item.colore_testo" class="ma-2" hide-inputs mode="hexa"
                canvas-height="100"></v-color-picker>
            </v-col>
          </v-row>
          <v-card>
            <v-toolbar class="indigo white--text" dense>
              <v-toolbar-title class="white--text">Sede Autista</v-toolbar-title>
              <v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDialogSedi()" v-bind="attrs" v-on="on" small>
                      <v-icon color="primary"> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Agg. Sede</span>
                </v-tooltip>
              </v-spacer>
            </v-toolbar>
            <v-data-table :headers="headers_sedi" fixed-header :items="selected_item.sedi.filter(e => e.validita == 1)"
              :key="table_key">
              <template v-slot:[`item.default`]="{ item }">
                <v-icon @click="selectPredefinito(item)"
                  :color="item.predefinito == 1 ? 'success' : ''">mdi-star</v-icon>
              </template>
              <template v-slot:[`item.orario_primo_appuntamento`]="{ item }">
                <v-text-field style="max-width: 100px" v-model="item.orario_primo_appuntamento" label="Orario app."
                  type="time"></v-text-field>
              </template>
              <template v-slot:[`item.step_incrementi`]="{ item }">
                <v-text-field style="max-width: 100px" v-model="item.step_incrementi" type="numer" min="0"
                  label="Step"></v-text-field>
              </template>
              <template v-slot:[`item.max_time`]="{ item }">
                <v-text-field style="max-width: 100px" v-model="item.max_time" label="Ora Max."
                  type="time"></v-text-field>
              </template>
              <template v-slot:[`item.elimina`]="{ item }">
                <v-icon @click="eliminaSede(item)" color="error">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </v-card>

        </v-card-text>
      </v-card>
    </template>

    <!-- Dialog Delete -->
    <v-dialog persistent v-model="delete_dialog" width="50%">
      <v-card>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Conferma eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto mr-5" @click="deleteAutista()" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small @click="delete_dialog = false">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <h3 class="ma-5">
            Sei sicuro di voler eliminare l'autista {{ selected_item.nome }}?
          </h3>
        </v-container>
      </v-card>
    </v-dialog>


    <!-- Dialog Area Competenza -->
    <v-dialog persistent v-model="dialog_area_competenza" width="650">
      <v-card>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">Aree Competenza - {{ selected_item?.cognome }} </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="saveAreaCompetenza()" class="ml-auto mr-5" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small @click="closeAreaCompetenza">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <!-- <v-treeview id="id" hoverable selectable :items="items_regioni" v-model="selected">
        </v-treeview> -->
        <v-data-table :headers="headers_aree" fixed-header :items="items_zone" :items-per-page="10"
          item-key="id_area_master" class="elevation-1 mt-5" height="60vh">
          <!-- Pulsante edit -->
          <template v-slot:[`item.seleziona`]="{ item }">
            <v-checkbox dense hide-details v-model="item.seleziona" />
          </template>
          <template v-slot:[`item.predefinito`]="{ item }">
            <v-checkbox @change="changeCheckboxSelezione(item)" dense hide-details v-model="item.predefinito" />
          </template>
        </v-data-table>
         <v-overlay :value="overlay_area">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
      </v-card>
    </v-dialog>

    <!-- Dialog sedi -->
    <v-dialog persistent v-model="dialog_sedi" width="60%">
      <v-card>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Seleziona la Sede </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggSedeAutista()" class="ml-auto mr-5" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiDialogSedi()" v-bind="attrs" v-on="on" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-data-table :headers="headers_sedi_filiale" fixed-header :items="items_sedi_vis" :key="table_key">
          <template v-slot:[`item.seleziona`]="{ item }">
            <v-checkbox v-model="item.selected"></v-checkbox>
          </template>
        </v-data-table>

      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
  <v-container fluid v-else>
    <!-- Tabella -->
    <v-data-table v-if="data_table === true" :headers="headers" fixed-header
      :items="autisti.filter((a) => a.validita == true).reverse()" :items-per-page="10" item-key="id_conduttore"
      calculate-widths class="elevation-1 mt-5" height="60vh">
      <!-- Intestazione tabella -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Autisti
            <v-icon color="white"> mdi-card-account-details </v-icon>
          </v-toolbar-title>
          <!-- Aggiungi autista -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="nuovoAutista()" class="ml-auto mr-n15" v-bind="attrs" v-on="on" small>
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuovo autista</span>
          </v-tooltip>
          <!-- Visualizza filtri -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto mr-5" v-bind="attrs" v-on="on" small
                @click="filters == true ? (filters = false) : (filters = true)">
                <v-icon color="purple"> mdi-filter </v-icon>
              </v-btn>
            </template>
            <span v-if="filters == false">Visualizza Filtri</span>
            <span v-else>Nascondi Filtri</span>
          </v-tooltip>
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="goBack()" class="ml-15" v-bind="attrs" v-on="on" small>
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Vai alla Dashboard</span>
          </v-tooltip>
        </v-toolbar>
        <!-- Input Filtri -->
        <v-row v-if="filters === true" justify="center" class="ma-1">
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="matricola_filter" label="Matricola" dense hide-details
              class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="nome_filter" label="Nome" dense hide-details class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="cognome_filter" label="Cognome" dense hide-details class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="codice_fiscale_filter" label="Cod. Fiscale" dense hide-details
              class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-text-field @change="filtra()" v-model="luogo_nascita_filter" label="Luogo di nascita" dense hide-details
              class="mt-5" />
          </v-col>
          <v-col cols="4" md="3">
            <v-autocomplete @change="filtra()" label="Patente" v-model="patente_filter" dense hide-details
              :items="items_patente" class="mt-5" item-text="descrizione" item-value="id_abilitazione" />
          </v-col>
          <v-col cols="4" md="3">
            <v-autocomplete @change="filtra()" v-model="veicolo_filter" label="Veicolo" dense :items="items_veicolo"
              item-text="targa" item-value="id_macchina" hide-details class="mt-5" />
          </v-col>
          <v-col cols="1">
            <!-- Reset filtri -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mt-5" v-bind="attrs" v-on="on" small @click="resetFiltri()">
                  <v-icon color="error"> mdi-filter-off </v-icon>
                </v-btn>
              </template>
              <span>Resetta Filtri</span>
            </v-tooltip>
          </v-col>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="filtra()" class="mt-4 success" v-bind="attrs" v-on="on">
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Filtra</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
      <!-- Pulsante edit -->
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="
              selectItem(item);
            data_table = false;
            ">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Dettagli</span>
        </v-tooltip>
      </template>
      <!-- Pulsante competenza -->
      <template v-slot:[`item.competenza`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="openDialogAreaComp(item)">
              <v-icon color="primary">mdi-map-search</v-icon>
            </v-btn>
          </template>
          <span>Aree competenza</span>
        </v-tooltip>
      </template>
      <!-- Patente -->
      <template v-slot:[`item.patente`]="{ item }">
        <template v-for="i in tot_abilitazioni">
          <span v-if="i.id_conduttore === item.id_conduttore" :key="i.id_conduttore_abilitazione">
            {{
              items_patente.filter((t) => t.id_abilitazione === i.id_tipo_abilitazione).length > 0 ?
                `${items_patente.filter((t) => t.id_abilitazione === i.id_tipo_abilitazione)[0].descrizione}`
                : "N/D"
            }}
          </span>
        </template>
      </template>
      <!-- Veicoli -->
      <template v-slot:[`item.predefinito`]="{ item }">
        {{
          items_veicolo.filter((m) => m.id_macchina === item.predefinito)
            .length > 0
            ? `${items_veicolo.filter(
              (m) => m.id_macchina === item.predefinito
            )[0].targa
            }`
            : "N/D"
        }}
      </template>

      <!-- Pulsante rimuovi -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="
              selectItem(item);
            delete_dialog = true;
            ">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Create/Edit template -->
    <template v-if="data_table === false">
      <v-card min-height="60vh" class="mt-5">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Autisti
            <v-icon color="white"> mdi-card-account-details </v-icon>
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto" @click="salvaAutista()" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva modifiche</span>
          </v-tooltip>
          <v-spacer />
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto" @click="data_table = true" v-bind="attrs" v-on="on" small>
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <!-- Input -->
          <v-row justify="center" class="ma-1">
            <v-col cols="4" md="3">
              <v-text-field v-model="selected_item.nome" label="Nome" dense hide-details />
            </v-col>
            <v-col cols="4" md="3">
              <v-text-field v-model="selected_item.cognome" label="Cognome" dense hide-details />
            </v-col>
            <v-col cols="4" md="3">
              <v-text-field type="number" hide-spin-buttons v-model.number="selected_item.matricola" label="Matricola"
                dense hide-details />
            </v-col>
            <v-col cols="3">
              <v-autocomplete label="Sede Default" v-model="selected_item.sede_default" :items="items_sedi"
                item-text="localita" item-value="id_azienda_sede" dense hide-details class="mt-5" />
            </v-col>
            <v-col cols="2">
              <v-text-field type="time" label="Ora Arrivo Default" v-model="selected_item.ora_primo_arrivo" dense
                hide-details :items="items_sedi" item-text="descrizione" item-value="id_azienda_sede" />
            </v-col>
            <v-col cols="4" md="4">
              <v-text-field v-model="selected_item.codice_fiscale" label="Cod. Fiscale" dense hide-details
                class="mt-5" />
            </v-col>
            <v-col cols="4" md="4">
              <v-text-field v-model="selected_item.luogo_nascita" label="Luogo di nascita" dense hide-details
                class="mt-5" />
            </v-col>
            <v-col cols="4" md="2">
              <v-text-field type="date" dense hide-details label="Data di nascita" v-model="selected_item.data_nascita"
                class="mt-5" />
            </v-col>
            <v-col cols="3">
              <v-autocomplete v-model="selected_item.patente" dense hide-details :items="items_patente" class="mt-5"
                multiple item-text="descrizione" item-value="id_abilitazione">
                <template #label>
                  <span>Patente<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules v-on:dialogModules="aggiornaAutocomplete" tipo="CONDUTTORE_ABILITAZIONE" nome="Patente"
                      setaction="settabelle" getaction="gettabelle" controller="Magazzino" filter="validita = 1"
                      :dati="[{ des: '' }]" />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-text-field type="date" dense hide-details label="Data scadenza patente" v-model="data_scadenza_patenti"
                class="mt-5" />
            </v-col>
            <v-col cols="3">
              <v-autocomplete label="Veicolo" v-model="selected_item.veicolo" dense hide-details multiple
                :items="items_veicolo" class="mt-5" item-text="targa" item-value="id_macchina" />
            </v-col>
            <v-col cols="3">
              <v-autocomplete label="Veicolo preferenziale" v-model.number="selected_item.predefinito" dense
                hide-details :items="items_veicolo.filter((v) =>
                  selected_item.veicolo.includes(v.id_macchina)
                )
                  " class="mt-5" item-text="targa" item-value="id_macchina" />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="selected_item.note" label="Note" dense hide-details class="mt-5" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

    <!-- Dialog Delete -->
    <v-dialog persistent v-model="delete_dialog" max-width="50%">
      <v-card min-height="30vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Conferma eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-auto mr-5" @click="deleteAutista()" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small @click="delete_dialog = false">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-card-text class="mt-5">
          <span class="black--text">
            Sei sicuro di voler eliminare l'autista {{ selected_item.nome }}?
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- Dialog Area Competenza -->
    <v-dialog persistent v-model="dialog_area_competenza" width="60%">
      <v-card>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Seleziona Aree Competenza</v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="saveAreaCompetenza()" class="ml-auto mr-5" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small @click="closeAreaCompetenza">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-treeview id="id_regione" hoverable selectable :items="items_regioni" v-model="selected">
        </v-treeview>


      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import moment from 'moment';


class Autista {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_conduttore", default_val: null },
      { nome: "matricola", default_val: "" },
      { nome: "nome", default_val: "" },
      { nome: "cognome", default_val: "" },
      { nome: "colore_testo", default_val: "" },
      { nome: "predefinito", default_val: 0 },
      { nome: "codice_fiscale", default_val: "" },
      { nome: "patente", default_val: [] },
      { nome: "data_nascita", default_val: null },
      { nome: "luogo_nascita", default_val: "" },
      { nome: "veicolo", default_val: [] },
      { nome: "macchine", default_val: [] },
      { nome: "note", default_val: "" },
      { nome: "sede_default", default_val: "" },
      { nome: "ora_primo_arrivo", default_val: "" },
      { nome: "sedi", default_val: [] },
      { nome: "abilitazioni", default_val: [] },
      { nome: "_abilitazioni", default_val: [] },
      { nome: "validita", default_val: true },
    ];

    return campi;
  }
}
// class Macchina {
//   constructor(arg = undefined) {
//     if (arg != undefined) {
//       const campi = this.setCampi();
//       campi.forEach((c) => {
//         this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
//       });
//     } else {
//       const campi = this.setCampi();
//       campi.forEach((c) => {
//         this[c.nome] = c.default_val;
//       });
//     }
//   }
//   // Metodo per resettare tutti i campi
//   reset() {
//     const campi = this.setCampi();

//     campi.forEach((c) => {
//       this[c.nome] = c.default_val;
//     });
//   }

//   setCampi() {
//     const campi = [
//       { nome: "id_conduttore_macchina", default_val: null },
//       { nome: "id_conduttore", default_val: null },
//       { nome: "id_macchina", default_val: null },
//       { nome: "predefinito", default_val: "" },
//       { nome: "data_inizio", default_val: "" },
//       { nome: "data_fine", default_val: "" },
//       { nome: "note", default_val: "" },
//       { nome: "validita", default_val: 1 },
//     ];

//     return campi;
//   }
// }
// class Abilitazione {
//   constructor(arg = undefined) {
//     if (arg != undefined) {
//       const campi = this.setCampi();
//       campi.forEach((c) => {
//         this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
//       });
//     } else {
//       const campi = this.setCampi();
//       campi.forEach((c) => {
//         this[c.nome] = c.default_val;
//       });
//     }
//   }
//   // Metodo per resettare tutti i campi
//   reset() {
//     const campi = this.setCampi();

//     campi.forEach((c) => {
//       this[c.nome] = c.default_val;
//     });
//   }

//   setCampi() {
//     const campi = [
//       { nome: "id_conduttore_abilitazione", default_val: null },
//       { nome: "id_conduttore", default_val: null },
//       { nome: "id_tipo_abilitazione", default_val: "" },
//       { nome: "data_inizio", default_val: "" },
//       { nome: "data_fine", default_val: "" },
//       { nome: "note", default_val: "" },
//       { nome: "validita", default_val: 1 },
//     ];

//     return campi;
//   }
// }
export default {
  name: "QLAutisti",

  components: {
    SnackbarQV,
    Modules: () => import("../../components/TOOLS/Modules"),
  },

  data() {
    return {
      // Variabili d'appoggio
      overlay: false,
      overlay_area: false,
      data_scadenza_patenti: null,
      azienda_sel: null,
      // Autista selezionato
      selected_item: new Autista(),
      // Filtri
      matricola_filter: "",
      nome_filter: "",
      cognome_filter: "",
      codice_fiscale_filter: "",
      luogo_nascita_filter: "",
      patente_filter: "",
      veicolo_filter: "",
      // Variabili tabella/crea/modifica/elimina/filtri
      data_table: true,
      delete_dialog: false,
      dialog_area_competenza: false,
      filters: false,
      table_key: 1,
      dialog_sedi: false,
      motrice_predefinita: null,
      // Array
      selected: [],
      items_patente: [],
      items_veicolo: [],
      items_veicolo_modello: [],
      tot_abilitazioni: [],
      abilitazioni_autista: [],
      tot_macchine_autista: [],
      macchine_autista: [],
      // autisti visibili
      autisti: [],
      // totale autisti
      tot_autisti: [],
      items_sedi: [],
      items_sedi_autista: [],
      motrici: [],
      items_zone: [],
      // Headers Tabella
      headers: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
        },
        {
          text: "Nome",
          value: "nome",
          filterable: false,
          sortable: false,
        },
        {
          text: "Cognome",
          value: "cognome",
          filterable: false,
          sortable: false,
        },

        {
          text: "Patente",
          value: "patente",
          filterable: false,
          sortable: false,
        },
        {
          text: "Veicolo",
          value: "predefinito",
          filterable: false,
          sortable: false,
        },
        {
          text: "Cod. Fiscale",
          value: "codice_fiscale",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
        },
      ],
      headers_ferrara: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
        },
        {
          text: "Aree Competenza",
          value: "competenza",
          filterable: false,
          sortable: false,
        },
        {
          text: "Nome",
          value: "nome",
          filterable: false,
          sortable: false,
        },
        {
          text: "Cognome",
          value: "cognome",
          filterable: false,
          sortable: false,
        },
        {
          text: "Competenze",
          value: "abilitazioni",
          filterable: false,
          sortable: false,
        },
        {
          text: "Veicolo",
          value: "predefinito",
          filterable: false,
          sortable: false,
        },
        {
          text: "Cod. Fiscale",
          value: "codice_fiscale",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
        },
      ],
      headers_aree: [
        {
          text: "Seleziona",
          value: "seleziona",
          filterable: false,
          sortable: false,
        },
        {
          text: "Predefinito",
          value: "predefinito",
          filterable: false,
          sortable: false,
        },
        {
          text: "Descrizone",
          value: "descrizione",
          filterable: false,
          sortable: false,
        },
        {
          text: "Ordinamento",
          value: "ordinamento",
          filterable: false,
          sortable: false,
        },
      ],
      headers_sedi: [
        {
          text: "Predefinito",
          value: "default",
          filterable: false,
          sortable: false,
        },
        {
          text: "Sede",
          value: "sede",
          filterable: false,
          sortable: false,
        },
        {
          text: "Orario Primo Appuntamento",
          value: "orario_primo_appuntamento",
          filterable: false,
          sortable: false,
        },
        {
          text: "Step Incrementi",
          value: "step_incrementi",
          filterable: false,
          sortable: false,
        },
        {
          text: "Max Time",
          value: "max_time",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          filterable: false,
          sortable: false,
        },
      ],
      headers_sedi_filiale: [
        {
          text: "Seleziona",
          value: "seleziona",
          filterable: false,
          sortable: false,
        },
        {
          text: "Sede",
          value: "descrizione",
          filterable: false,
          sortable: false,
        },
        {
          text: "Indirizzo",
          value: "indirizzo",
          filterable: false,
          sortable: false,
        },
        {
          text: "Località",
          value: "localita",
          filterable: false,
          sortable: false,
        },
      ],
      items_regioni: [],
      items_sedi_vis: [],
    };
  },

  computed: {},

  watch: {
    variabile: {
      immediate: true,

      handler() { },
    },
  },

  methods: {
    changeMacchine() {
      this.motrice_predefinita = null;
    },
    getZone() {
      const getconfig = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getzone",
          id_regione: null,
          id_provincia: null,
          id_comune: null
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getconfig).then((res) => {
        this.overlay = false;
        this.items_zone = [];
        if (res.status === 200 || res.status === 204) {
          this.items_zone = res.data.result;
          console.log("items_zone", this.items_zone);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      }).catch((err) => {
        this.overlay = false;
        this.$refs.SnackbarQV.print("error", err.toString());
      });
    },
    aggSedeAutista() {
      this.items_sedi_vis.forEach(e => {
        if (e.selected == true) {
          let obj_sede = {
            id_conduttore_sede: null,
            id_conduttore: this.selected_item.id_conduttore,
            id_azienda_sede: e.id_azienda_sede,
            sede: e.descrizione,
            orario_primo_appuntamento: "08:30",
            predefinito: 0,
            step_incrementi: "15",
            max_time: "12:00",
            validita: 1,
          }
          this.selected_item.sedi.push(obj_sede);
        }
      })
      this.dialog_sedi = false;
      this.items_sedi_vis = [];
      this.items_sedi.forEach(e => {
        e.selected = false;
      })
    },
    chiudiDialogSedi() {
      this.items_sedi_vis.forEach(e => {
        e.selected = false;
      })
      this.dialog_sedi = false;
      this.items_sedi_vis = [];
    },
    closeAreaCompetenza() {
      this.dialog_area_competenza = false;
      this.selected_item = new Autista();
      this.items_zone.forEach(e => {
        e.seleziona = false;
        e.predefinito = false;
      })
    },
    getAreaCompetenza() {
      this.overlay = true;
      const getconfig = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getzonecompetenza",
        },
      };
      this.$store.dispatch("api", getconfig).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          res.data.result.forEach(r => {
            this.autisti.forEach(a => {
              if (r.id_conduttore == a.id_conduttore) {
                a.zone = r.zone != null ? r.zone : [];
              }
            })
            console.log("autisti", this.autisti);

          })
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
        this.overlay = false;
      });
    },
    getMotrici() {
      this.overlay = true;
      const request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getmotrici",
          id_macchina: null,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          this.motrici = res.data.result;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
        this.overlay = false;
      }).catch((err) => {
        this.overlay = false;
        if (err) {
          this.$refs.SnackbarQV.print("error", err.toString());
        }
      });
    },
    changeCheckboxSelezione(item) {
      console.log("item checkbox", item);
      // item.seleziona = item.predefinito == true ? true : false;
    },
    getSedi() {
      const getconfig = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getsedifiliali",
          id_regione: null,
          id_provincia: null,
          id_comune: null
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getconfig).then((res) => {
        this.overlay = false;
        if (res.status === 200 || res.status === 204) {
          this.items_sedi = res.data.result;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    // getConduttoreSedi() {
    //   const getconfig = {
    //     controller: "logistic",
    //     method: "POST",
    //     richiesta: {
    //       token: localStorage.getItem("user_token"),
    //       action: "getconduttoresedi",
    //     },
    //   };
    //   this.overlay = true;
    //   this.$store.dispatch("api", getconfig).then((res) => {
    //     this.overlay = false;
    //     if (res.status === 200 || res.status === 204) {
    //       this.items_sedi_autista = res.data.result;
    //       this.items_sedi_autista.forEach(sa => {
    //         if (this.selected_item.sedi.length != 0) {
    //           this.selected_item.sedi.forEach(e => {
    //             if (e.id_conduttore_sede == sa.id_conduttore_sede) {

    //               sa.orario_primo_appuntamento = e.orario_primo_appuntamento;
    //               sa.max_time = e.max_time;
    //               sa.step_incrementi = e.step_incrementi;
    //               sa.predefinito = e.predefinito;
    //               sa.seleziona = true;

    //               console.log("trovata sede autista", sa);
    //             }
    //           })
    //         }

    //       })
    //     } else {
    //       this.$refs.SnackbarQV.print(
    //         "orange",
    //         `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
    //       );
    //     }
    //   });
    // },
    getRegioni() {
      const getconfig = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getregioniprovince",
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getconfig).then((res) => {
        this.overlay = false;
        if (res.status === 200 || res.status === 204) {
          this.items_regioni = res.data.result;
          this.items_regioni.forEach(i => {
            i.children = i.province;
            i.name = i.regione;
            i.id = i.id_regione + moment().valueOf() + Math.random() * 100;
            i.children.forEach(p => {
              p.name = p.provincia;
              p.id = p.id_provincia + moment().valueOf() + Math.random() * 100;
            })
          })
          // this.items_regioni.forEach(e => {
          //   e.name = e.regione;
          //   e.id = e.id_regione + moment().valueOf() + Math.random() * 100;
          //   this.getProvince(e)
          // })
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    // getProvince(arg) {
    //   const getconfig = {
    //     controller: "logistic",
    //     method: "POST",
    //     richiesta: {
    //       token: localStorage.getItem("user_token"),
    //       action: "getprovince",
    //       id_regione: arg.id_regione

    //     },
    //   };
    //   this.overlay = true;
    //   this.$store.dispatch("api", getconfig).then((res) => {
    //     this.overlay = false;
    //     if (res.status === 200) {
    //       this.items_regioni.forEach(e => {
    //         if (e.id_regione == arg.id_regione) {
    //           e.children = res.data.result;
    //           e.children.forEach(c => {
    //             c.name = c.provincia;
    //             c.id = c.id_provincia + moment().valueOf() + Math.random() * 100;
    //           })
    //         }

    //       })
    //     } else {
    //       this.$refs.SnackbarQV.print(
    //         "orange",
    //         `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
    //       );
    //     }
    //   });
    // },
    openDialogAreaComp(arg) {
      this.items_zone.forEach(e => {
        e.seleziona = false;
        e.predefinito = false;
      })
      console.log("seleziona autista", arg);

      this.selected_item = arg;

      this.items_zone.forEach(e => {
        this.selected_item.zone_di_competenza.forEach(z => {
          if (e.id_zona_master == z.id_zona_master) {
            e.seleziona = true;
            e.predefinito = z.predefinito == 1 ? true : false;
          }
        })

      })
      this.dialog_area_competenza = true;
    },
    // openDialogAreaComp(arg) {

    //   this.selected = [];
    //   this.selected_item = arg;

    //   this.items_regioni.forEach(e => {
    //     if (this.selected_item.zone_di_competenza.length != 0) {
    //       this.selected_item.zone_di_competenza.forEach(z => {
    //         console.log("z, e", z, e);

    //         if (z.id_regione == e.id_regione) {
    //           console.log("entra if regione");
    //           e.province.forEach(c => {
    //             if (c.id_provincia == z.id_provincia) {
    //               console.log("entra if provincia");
    //               let obj_selected = c.id;
    //               this.selected.push(obj_selected);
    //             }
    //           })

    //           console.log("selected", this.selected);

    //         }
    //       })
    //     }
    //   })
    //   this.dialog_area_competenza = true;
    // },
    // Autista selezionato
    selectItem(item) {
      console.log("itemmmm", item);

      // Seleziono l'autista
      this.selected_item = new Autista(JSON.parse(JSON.stringify(item)));

      if (this.azienda_sel == "ferraraquarzi") {
        console.log("entro 1");
        if (this.selected_item.sedi.length != 0) {
          console.log("entro sede");
          this.selected_item.sedi.forEach(e => {
            e.sede = this.items_sedi.filter(s => s.id_azienda_sede == e.id_azienda_sede)[0].descrizione;
            e.validita = 1;
          })
        }

        if (this.selected_item.macchine.length != 0) {
          console.log("entro motrici");
          this.selected_item.macchine.forEach(m => {
            if (m.predefinito == 1) {
              this.motrice_predefinita = m;
              console.log("trovato motrice predefinito", this.motrice_predefinita);

            }
          })
        }
        if (this.selected_item.abilitazioni.length != 0) {
          console.log("entro abilitazioni");
          this.selected_item.abilitazioni.forEach(a => {
            this.selected_item._abilitazioni.push(a.id_tipo_abilitazione)
          })
        }
      } else {
        // Trovo le abilitazioni dell'autista selezionato se ce ne sono

        // this.abilitazioni_autista = this.tot_abilitazioni.filter(
        //   (a) => a.id_conduttore == this.selected_item.id_conduttore
        // );

        // if (this.abilitazioni_autista.length > 0)
        //   this.data_scadenza_patenti = this.formatData(this.abilitazioni_autista[0].data_fine, true);
        // else
        //   this.data_scadenza_patenti = null;

        // Riempo il campo patente dell'autista con gli id delle sue abilitazioni
        // this.abilitazioni_autista.forEach((a) =>
        //   this.selected_item.patente.push(a.id_tipo_abilitazione)
        // );

        // this.macchine_autista = this.tot_macchine_autista.filter(
        //   (m) => m.id_conduttore == this.selected_item.id_conduttore
        // );

        item.macchine.forEach((m) => {
          this.selected_item.veicolo.push(m.id_macchina);
        });



        console.log("item selezionato", this.selected_item);

      }






      // this.getConduttoreSedi();
    },
    // Nuovo Autista
    nuovoAutista() {
      this.data_table = false;
      this.selected_item = new Autista();
    },
    // Elimina autista
    deleteAutista() {
      let request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "saveconduttore",
          conduttore: {
            id_conduttore: this.selected_item.id_conduttore,
            cognome: this.selected_item.cognome,
            nome: this.selected_item.nome,
            matricola: this.selected_item.matricola,
            codice_fiscale: this.selected_item.codice_fiscale,
            sede_default: this.selected_item.sede_default,
            ora_primo_arrivo: this.selected_item.ora_primo_arrivo,
            note: this.selected_item.note,
            validita: 0,
          },
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", request).then(() => {
        this.overlay = false;
        this.getAutisti();
        this.$refs.SnackbarQV.print("success", "Modifica effettuata con successo!");
      });
      this.filtra();
      this.delete_dialog = false;
    },
    openDialogSedi() {
      this.items_sedi_vis = [];
      this.items_sedi.forEach(e => {
        // Verifica se l'elemento non esiste in selected_item.sedi
        if (!this.selected_item.sedi.some(s => s.id_azienda_sede === e.id_azienda_sede &&
          s.validita != 0)) {
          this.items_sedi_vis.push(e);
        }
      })
      this.dialog_sedi = true;
    },
    selectMotricePred() {
      this.selected_item.macchine.forEach(e => {
        if (this.motrice_predefinita == e.id_macchina) {
          e.predefinito = 1
        } else {
          e.predefinito = 0;
        }
      })
    },
    saveAreaCompetenza() {
      console.log("asd");
      
      this.overlay_area = true;
      let arr = [];
      console.log("this.items_zone", this.items_zone);


      this.items_zone.forEach(e => {
        if (e.seleziona == true) {
          let obj = {
            id_zona_master: e.id_zona_master,
            predefinito: e.predefinito == true ? 1 : 0,
          }
          arr.push(obj);
        }
      })

      let request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "savezonecompetenza",
          id_conduttore: this.selected_item.id_conduttore,
          zone: arr,
        },
      };
      this.$store.dispatch("api", request).then((res) => {

        if (res.status == 200) {
          this.overlay_area = false;
          this.dialog_area_competenza = false;
          this.getAutisti();
          this.$refs.SnackbarQV.print(
            "success", "Salvato con successo."
          );
        } else {
          this.$refs.SnackbarQV.print(
            "error", "Si è verificato un problema."
          );
        }
        this.overlay_area = false;
      });
      
    },
    // Prendi gli autisti dal db
    getAutisti() {
      const getconduttori = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getconduttori",
          token: localStorage.getItem("user_token"),
          id_conduttore: null,
        },
      };
      // let getconduttoremacchine = {
      //   controller: "logistic",
      //   method: "POST",
      //   richiesta: {
      //     action: "getconduttoremacchine",
      //     token: localStorage.getItem("user_token"),
      //     id_conduttore: null,
      //     id_conduttore_macchina: null,
      //     // filter: `validita = 1`,
      //   },
      // };
      // const getabilitazioni = {
      //   controller: "logistic",
      //   method: "POST",
      //   richiesta: {
      //     action: "getconduttoreabilitazioni",
      //     token: localStorage.getItem("user_token"),
      //     id_conduttore: null,
      //     id_conduttore_abilitazione: null,
      //   },
      // };
      //GET CONDUTTORI
      this.overlay = true;
      this.$store.dispatch("api", getconduttori).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          this.autisti = [];
          this.tot_autisti = [];

          // console.table(res.data);

          res.data.result.forEach((e) => {
            e.zone = [];
            if (e.validita == true) {
              if (e.data_nascita != null) {
                e.data_nascita = e.data_nascita.substr(0, 10);
              }
              this.tot_autisti.push(e);
            }
          });
          // // GET ABILITAZIONI
          // this.overlay = true;
          // this.$store.dispatch("api", getabilitazioni).then((res) => {
          //   this.overlay = false;
          //   if (res.status === 200) {
          //     this.tot_abilitazioni = [];
          //     res.data.result.forEach((e) => {
          //       if (e.validita == true) {
          //         this.tot_abilitazioni.push(e);
          //       }
          //     });
          //   } else {
          //     this.$refs.SnackbarQV.print(
          //       "orange",
          //       `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          //     );
          //   }
          // });
          //GET MACCHINE CONDUTTORE
          // this.overlay = true;
          // this.$store.dispatch("api", getconduttoremacchine).then((res) => {
          //   this.overlay = false;
          //   if (res.status == 200) {
          //     this.tot_macchine_autista = [];
          //     res.data.result.forEach((e) => {
          //       if (e.validita == true) {
          //         this.tot_macchine_autista.push(e);
          //       }
          //     });
          //     // IMPOSTO IL CAMPO PREDEFINITO DI AUTISTA CON L'ID_MACCHINA
          //     // DEL VEICOLO PREDEFINITO SE ESISTE
          //     this.tot_autisti.forEach((a) => {
          //       let macchine_autista = this.tot_macchine_autista.filter(
          //         (m) => m.id_conduttore == a.id_conduttore
          //       );
          //       macchine_autista.forEach((m) => {
          //         if (m.predefinito == 1) {
          //           a.predefinito = m.id_macchina;
          //         }
          //       });
          //     });
          //   } else {
          //     this.$refs.SnackbarQV.print(
          //       "orange",
          //       "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          //     );
          //   }
          // });
          this.autisti = Array.from(this.tot_autisti);
          console.log("this.autisti", this.autisti);

        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    // Aggiungi autista
    salvaAutista() {
      if (this.selected_item.nome == "" || this.selected_item.cognome == "") {
        return this.$refs.SnackbarQV.print("orange", "Inserire nome e cognome");
      }
      if (this.azienda_sel == "ferraraquarzi" && this.motrice_predefinita == null) {
        return this.$refs.SnackbarQV.print("orange", "Inserire una motrice predefinita");
      }
      let arr = [];

      if (this.selected_item.sedi.length != 0) {
        this.selected_item.sedi.forEach(e => {
          if (e.id_conduttore_sede == null && e.validita == 0) {
            console.log("item non valido");
          } else {
            arr.push(e);
          }
        })
      }

      if (this.selected_item.macchine.length != 0) {
        this.selected_item.macchine.forEach(m => {
          m.selected_item = this.selected_item.id_conduttore;
        })
      }




      let request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "saveconduttore",
          conduttore: {
            id_conduttore: this.selected_item.id_conduttore,
            cognome: this.selected_item.cognome,
            nome: this.selected_item.nome,
            colore_testo: this.selected_item.colore_testo,
            matricola: this.selected_item.matricola,
            data_nascita: this.selected_item.data_nascita,
            luogo_nascita: this.selected_item.luogo_nascita,
            codice_fiscale: this.selected_item.codice_fiscale,
            sede_default: this.selected_item.sede_default,
            ora_primo_arrivo: this.selected_item.ora_primo_arrivo,
            note: this.selected_item.note,
            _abilitazioni: this.selected_item._abilitazioni.toString(),
            sedi: arr,
            macchine: this.selected_item.macchine.length != 0 ? this.selected_item.macchine : [],
            validita: 1,
          },
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.getAutisti();
          this.filtra();
          this.data_table = true;
        }
      }).catch((err) => {
        this.overlay = false;
        if (err) {
          this.$refs.SnackbarQV.print("error", err.toString());
        }
      });
    },
    // salvaAutista() {
    //   if (this.selected_item.nome == "" || this.selected_item.cognome == "") {
    //     return this.$refs.SnackbarQV.print("orange", "Inserire nome e cognome");
    //   }
    //   let arr = [];

    //   if (this.selected_item.sedi.length != 0) {
    //     this.selected_item.sedi.forEach(e => {
    //       if (e.id_conduttore_sede == null && e.validita == 0) {
    //         console.log("item non valido");
    //       } else {
    //         arr.push(e);
    //       }
    //     })
    //   }

    //   if (this.selected_item.macchine.length != 0) {
    //       this.selected_item.macchine.forEach(m => {
    //         m.selected_item = this.selected_item.id_conduttore;
    //       })
    //     }




    //   let request = {
    //     controller: "logistic",
    //     method: "POST",
    //     richiesta: {
    //       token: localStorage.getItem("user_token"),
    //       action: "saveconduttore",
    //       conduttore: {
    //         id_conduttore: this.selected_item.id_conduttore,
    //         cognome: this.selected_item.cognome,
    //         nome: this.selected_item.nome,
    //         matricola: this.selected_item.matricola,
    //         data_nascita: this.selected_item.data_nascita,
    //         luogo_nascita: this.selected_item.luogo_nascita,
    //         codice_fiscale: this.selected_item.codice_fiscale,
    //         sede_default: this.selected_item.sede_default,
    //         ora_primo_arrivo: this.selected_item.ora_primo_arrivo,
    //         note: this.selected_item.note,
    //         sedi: arr,
    //         macchine: this.selected_item.macchine.length != 0 ? this.selected_item.macchine : [],
    //         validita: 1,
    //       },
    //     },
    //   };
    //   this.overlay = true;
    //   this.$store.dispatch("api", request).then((res) => {
    //     this.overlay = false;
    //     if (res.status == 200) {
    //       // ARRAY PER VERIFICARE SE SONO STATE RIMOSSE ABILITAZIONI/VEICOLI
    //       let abilitazioni_rimosse = [];
    //       let veicoli_rimossi = [];
    //       this.selected_item.patente.forEach((p) => {
    //         if (
    //           this.abilitazioni_autista.filter(
    //             (a) => p == a.id_tipo_abilitazione
    //           ).length > 0
    //         ) {
    //           // ABILITAZIONI DELL'AUTISTA NON RIMOSSE
    //           abilitazioni_rimosse.push(
    //             this.abilitazioni_autista.filter(
    //               (a) => p == a.id_tipo_abilitazione
    //             )[0]
    //           );
    //         }
    //       });
    //       // ABILITAZIONI DELL'AUTISTA RIMOSSE
    //       this.abilitazioni_autista
    //         .filter((a) => abilitazioni_rimosse.indexOf(a) === -1)
    //         .forEach((a) => (a.validita = 0));

    //       // VERIFICO CHE NON SIANO STATI RIMOSSE DEI VEICOLI
    //       this.selected_item.veicolo.forEach((v) => {
    //         if (
    //           this.macchine_autista.filter((m) => v == m.id_macchina).length > 0
    //         ) {
    //           // VEICOLI DELL'AUTISTA NON RIMOSSI
    //           veicoli_rimossi.push(
    //             this.macchine_autista.filter((m) => v == m.id_macchina)[0]
    //           );
    //         }
    //       });
    //       // VEICOLI DELL'AUTISTA RIMOSSI
    //       this.macchine_autista
    //         .filter((m) => veicoli_rimossi.indexOf(m) === -1)
    //         .forEach((v) => (v.validita = 0));

    //       // ciclo le abilitazioni selezionate
    //       this.selected_item.patente.forEach((p) => {
    //         // controllo che non vengano create abilitazioni che esistono gia
    //         if (
    //           this.abilitazioni_autista.filter(
    //             (a) => a.id_tipo_abilitazione == p
    //           ).length == 0
    //         ) {
    //           // imposto id_tipo_abilitazione e id_conduttore alle nuove abilitazioni
    //           let a = new Abilitazione();
    //           a.id_tipo_abilitazione = p;
    //           a.id_conduttore = res.data.result.id_conduttore;
    //           this.abilitazioni_autista.push(a);
    //         }
    //       });
    //       this.abilitazioni_autista.forEach((a, i) => {
    //         a.data_fine = a.validita ? this.data_scadenza_patenti : null;
    //         // SALVO LE ABILITAZIONI
    //         let request = {
    //           controller: "logistic",
    //           method: "POST",
    //           richiesta: {
    //             token: localStorage.getItem("user_token"),
    //             action: "saveconduttoreabilitazione",
    //             abilitazione: a,
    //           },
    //         };
    //         this.overlay = true;
    //         this.$store.dispatch("api", request).then((res) => {
    //           this.overlay = false;
    //           if (i == this.abilitazioni_autista.length - 1) {
    //             this.getAutisti();
    //             this.$refs.SnackbarQV.print(
    //               "success",
    //               "Autista salvato correttamente"
    //             );
    //           }
    //           if (res.status != 200) {
    //             this.$refs.SnackbarQV.print(
    //               "orange",
    //               "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //             );
    //           }
    //         });
    //       });
    //       // ciclo i veicoli selezionati
    //       this.selected_item.veicolo.forEach((v) => {
    //         // controllo che non vengano creati veicoli che esistono gia
    //         if (
    //           this.macchine_autista.filter((m) => m.id_macchina == v).length ==
    //           0
    //         ) {
    //           // imposto id_tipo_abilitazione e id_conduttore alle nuove abilitazioni
    //           let m = new Macchina();
    //           m.id_macchina = v;
    //           m.id_conduttore = res.data.result.id_conduttore;
    //           this.macchine_autista.push(m);
    //         }
    //       });

    //       this.macchine_autista.forEach((v, i) => {
    //         v.id_macchina == this.selected_item.predefinito
    //           ? (v.predefinito = 1)
    //           : (v.predefinito = 0);
    //         // CREO I NUOVI VEICOLI
    //         let request = {
    //           controller: "logistic",
    //           method: "POST",
    //           richiesta: {
    //             token: localStorage.getItem("user_token"),
    //             action: "saveconduttoremacchina",
    //             macchina: v,
    //           },
    //         };
    //         this.overlay = true;
    //         this.$store.dispatch("api", request).then((res) => {

    //           if (i == this.macchine_autista.length - 1) {
    //             this.getAutisti();
    //             this.$refs.SnackbarQV.print(
    //               "success",
    //               "Autista salvato correttamente"
    //             );
    //           }
    //           if (res.status != 200) {
    //             this.$refs.SnackbarQV.print(
    //               "orange",
    //               "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //             );
    //           }
    //         });
    //         this.overlay = false;
    //       });
    //     } else {
    //       this.$refs.SnackbarQV.print(
    //         "orange",
    //         "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //       );
    //     }
    //   });

    //   this.getAutisti();
    //   this.filtra();
    //   this.data_table = true;
    // },
    aggiornaAutocomplete() {
      let getpatenti = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getabilitazioni",
          token: localStorage.getItem("user_token"),
          filter: `validita = 1`,
        },
      };

      this.overlay = true;
      this.$store.dispatch("api", getpatenti).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.items_patente = res.data.result.length != 0 ? res.data.result : [];
          console.log("items_patente", this.items_patente);

        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });

      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
          id_tipo_macchina: 33570,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getlistamacchine).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          this.items_veicolo = [];
          res.data.macchine.forEach((e) => {
            if (e.extra.length > 0) {
              this.items_veicolo.push(e.extra[0]);
            }
          });
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "EG_MODELLO_VEICOLO",
          filter: `validita = 1`,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.items_veicolo_modello = res.data ? res.data : [];
          // console.table(res.data);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
    },

    // Filtri
    filtra() {
      console.log("autisti?", this.tot_autisti);

      /* Preparo un array temporaneo in cui
       * collezionare i autisti filtrati */
      let autisti_tmp = [];
      this.tot_autisti.forEach((a) => {
        autisti_tmp.push(new Autista(a));
      });

      //Filtro per matricola
      if (this.matricola_filter != "") {
        let res = [];
        autisti_tmp.forEach((elem) => {
          if (
            elem.matricola
              .toUpperCase()
              .includes(this.matricola_filter.toUpperCase())
          ) {
            res.push(new Autista(elem));
          }
        });
        autisti_tmp = [];
        res.forEach((e) => {
          autisti_tmp.push(new Autista(e));
        });
      }
      //Filtro per nome
      if (this.nome_filter != "") {
        let res = [];
        autisti_tmp.forEach((elem) => {
          if (
            elem.nome.toUpperCase().includes(this.nome_filter.toUpperCase())
          ) {
            res.push(new Autista(elem));
          }
        });
        autisti_tmp = [];
        res.forEach((e) => {
          autisti_tmp.push(new Autista(e));
        });
      }
      //Filtro per cognome
      if (this.cognome_filter != "") {
        let res = [];
        autisti_tmp.forEach((elem) => {
          if (
            elem.cognome
              .toUpperCase()
              .includes(this.cognome_filter.toUpperCase())
          ) {
            res.push(new Autista(elem));
          }
        });
        autisti_tmp = [];
        res.forEach((e) => {
          autisti_tmp.push(new Autista(e));
        });
      }
      //Filtro per codice_fiscale
      if (this.codice_fiscale_filter != "") {
        let res = [];
        autisti_tmp.forEach((elem) => {
          if (
            elem.codice_fiscale
              .toUpperCase()
              .includes(this.codice_fiscale_filter.toUpperCase())
          ) {
            res.push(new Autista(elem));
          }
        });
        autisti_tmp = [];
        res.forEach((e) => {
          autisti_tmp.push(new Autista(e));
        });
      }
      //Filtro per veicolo
      if (this.veicolo_filter != "") {
        let res = [];
        autisti_tmp.forEach((elem) => {
          console.log("veicolo", this.items_veicolo);
          this.items_veicolo.forEach(m => {
            if (m.id_macchina === this.veicolo_filter) {
              if (elem.predefinito == m.id_macchina) {
                res.push(new Autista(elem));
              }
            }
          })

        });
        autisti_tmp = [];
        res.forEach((e) => {
          autisti_tmp.push(new Autista(e));
        });
      }
      //Filtro per luogo_nascita
      if (this.luogo_nascita_filter != "") {
        let res = [];
        autisti_tmp.forEach((elem) => {
          if (
            elem.luogo_nascita
              .toUpperCase()
              .includes(this.luogo_nascita_filter.toUpperCase())
          ) {
            res.push(new Autista(elem));
          }
        });
        autisti_tmp = [];
        res.forEach((e) => {
          autisti_tmp.push(new Autista(e));
        });
      }
      // Filtro per patente
      if (
        this.patente_filter !== "" &&
        typeof this.patente_filter !== "object"
      ) {
        let res = [];
        autisti_tmp.forEach((elem) => {
          this.tot_abilitazioni.forEach((a) => {
            if (
              a.id_tipo_abilitazione === this.patente_filter &&
              a.id_conduttore == elem.id_conduttore
            ) {
              res.push(new Autista(elem));
            }
          });
        });
        autisti_tmp = [];
        res.forEach((e) => {
          autisti_tmp.push(new Autista(e));
        });
      }

      // Ricostruisco gli autisti visualizzati in base ai filtri aggiunti.
      this.autisti = [];
      this.autisti = Array.from(autisti_tmp);
    },
    resetFiltri() {
      this.nome_filter = "";
      this.matricola_filter = "";
      this.cognome_filter = "";
      this.codice_fiscale_filter = "";
      this.data_nascita_filter = "";
      this.luogo_nascita_filter = "";
      this.patente_filter = "";
      this.veicolo_filter = "";
      this.filtra();
    },

    formatData(arg, american_format) {
      return arg != null && arg != ""
        ? moment(arg).format(american_format ? "YYYY-MM-DD" : "DD/MM/YY")
        : "";
    },
    selectPredefinito(arg) {
      console.log("predefinito", arg);

      this.selected_item.sedi.forEach(e => {
        if (e.id_azienda_sede == arg.id_azienda_sede) {
          console.log("predefinito trovato", arg);
          e.predefinito = 1;
        } else {
          e.predefinito = 0;
        }
      })

      this.table_key = this.table_key + 1;
      console.log("key table", this.table_key);
    },
    eliminaSede(arg) {
      arg.validita = 0;
    },
    goBack() {
      this.$router.push("/home/quicklogistic");
    },
  },
  created() {
    this.getAutisti();
    this.getSedi();
    //this.getConduttoreSedi();
  },
  async mounted() {
    this.azienda_sel = localStorage.prefisso_utente;
    if (this.azienda_sel == "ferraraquarzi") {
      this.getRegioni();
      this.getMotrici();
      // this.getAreaCompetenza();
      this.getZone();
    }

    await this.aggiornaAutocomplete();
  },
};
</script>
<!-- 1270 righe -->
<style scoped></style>